import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorHistoryChangesComponent } from './sensor-history-changes.component';
import {DxDataGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [SensorHistoryChangesComponent],
    imports: [
        CommonModule,
        DxDataGridModule
    ],
  exports: [SensorHistoryChangesComponent]
})
export class SensorHistoryChangesModule { }
